const numberLimit = {
  install(Vue) {
    Vue.directive("numberLimit", {
      bind(el, binding) {
        // 确保指令作用于 input 元素
        const input = el.tagName === "INPUT" ? el : el.querySelector("input");
        if (!input) {
          console.warn("v-number-limit 必须绑定在 input 元素或其父元素上");
          return;
        }

        // 获取位数限制参数
        let maxDigits =
          binding.value !== undefined ? Number(binding.value) : null;

        // 保存当前合法的输入值
        let lastValidRawValue = input.value;

        // 标记是否正在使用输入法组合输入
        let isComposing = false;

        // 工具函数: 检查字符串是否合法
        function isValidNumberString(str) {
          if (str === "" || str === "-") return true;
          if (!/^\d+$/.test(str)) return false;

          // 1. 先检查位数限制（如果设置了）
          // if (maxDigits !== null && str.length > maxDigits) {
          //   return false;
          // }
          if (maxDigits !== null) {
            return str.length <= maxDigits;
          }
          // 2. 再检查是否超过最大安全整数
          const num = Number(str);
          if (isNaN(num)) return false;
          if (num > Number.MAX_SAFE_INTEGER) return false;

          return true;
        }

        // 更新输入框值并触发事件
        function setInputValue(value, force = false) {
          if (input.value !== value || force) {
            input.value = value;
            // 触发input事件更新v-model
            const event = new Event("input", {
              bubbles: true,
              cancelable: true,
            });
            input.dispatchEvent(event);
          }
        }

        // 处理组合输入开始
        const onCompositionStart = () => {
          isComposing = true;
        };

        // 处理组合输入结束
        const onCompositionEnd = (event) => {
          isComposing = false;

          // 组合输入结束后，手动触发一次输入处理
          const rawValue = event.target.value;
          const filtered = rawValue.replace(/[^\d]/g, "");

          if (filtered === "") {
            setInputValue("");
            lastValidRawValue = "";
          } else if (isValidNumberString(filtered)) {
            setInputValue(filtered);
            lastValidRawValue = filtered;
          } else {
            setInputValue(lastValidRawValue);
          }
        };

        // 输入事件处理函数
        const onInput = (event) => {
          // 如果正在组合输入，暂时不处理，等待组合结束
          if (isComposing) {
            return;
          }

          const rawValue = event.target.value;

          // 过滤非数字字符
          const filtered = rawValue.replace(/[^\d]/g, "");

          // 情况1: 过滤后为空
          if (filtered === "") {
            setInputValue("");
            lastValidRawValue = "";
            return;
          }

          // 情况2: 检查是否合法
          if (isValidNumberString(filtered)) {
            // 合法：更新输入框并保存
            setInputValue(filtered);
            lastValidRawValue = filtered;
          } else {
            // 不合法：恢复到最后合法值
            setInputValue(lastValidRawValue);
          }
        };

        // 监听blur事件，确保最终值是合法的
        const onBlur = () => {
          // 如果正在组合输入，先结束组合
          if (isComposing) {
            isComposing = false;
          }

          if (input.value && !isValidNumberString(input.value)) {
            setInputValue(lastValidRawValue);
          }
        };

        // 保存处理函数到元素上，方便后续解绑
        el._numberOnlyHandler = onInput;
        el._compositionStartHandler = onCompositionStart;
        el._compositionEndHandler = onCompositionEnd;
        el._numberOnlyBlurHandler = onBlur;
        el._maxDigits = maxDigits;

        // 绑定事件
        input.addEventListener("input", onInput);
        input.addEventListener("compositionstart", onCompositionStart);
        input.addEventListener("compositionend", onCompositionEnd);
        input.addEventListener("blur", onBlur);

        // 初始化处理
        if (input.value) {
          const filtered = input.value.replace(/[^\d]/g, "");
          if (isValidNumberString(filtered)) {
            if (input.value !== filtered) {
              input.value = filtered;
              lastValidRawValue = filtered;
              // 触发一次更新，确保v-model同步
              const event = new Event("input", {
                bubbles: true,
                cancelable: true,
              });
              input.dispatchEvent(event);
            } else {
              lastValidRawValue = input.value;
            }
          } else {
            // 初始值不合法，清空
            input.value = "";
            lastValidRawValue = "";
            const event = new Event("input", {
              bubbles: true,
              cancelable: true,
            });
            input.dispatchEvent(event);
          }
        }
      },

      // 添加update钩子，处理参数变化
      update(el, binding) {
        const input = el.tagName === "INPUT" ? el : el.querySelector("input");
        if (!input) return;

        const newMaxDigits =
          binding.value !== undefined ? Number(binding.value) : null;

        // 如果位数限制变化了，更新并重新验证
        if (el._maxDigits !== newMaxDigits) {
          el._maxDigits = newMaxDigits;

          // 重新验证当前值
          if (input.value) {
            const filtered = input.value.replace(/[^\d]/g, "");
            const isValid = (str) => {
              if (str === "") return true;
              if (!/^\d+$/.test(str)) return false;
              // if (newMaxDigits !== null && str.length > newMaxDigits)
              //   return false;
              if (newMaxDigits !== null) {
                return str.length <= newMaxDigits;  // ← 以 maxDigits 为准
              }
              const num = Number(str);
              if (isNaN(num)) return false;
              if (num > Number.MAX_SAFE_INTEGER) return false;
              return true;
            };

            if (!isValid(filtered)) {
              // 当前值不合法，清空
              input.value = "";
              const event = new Event("input", {
                bubbles: true,
                cancelable: true,
              });
              input.dispatchEvent(event);
            }
          }
        }
      },

      // 添加unbind钩子，清理事件监听
      unbind(el) {
        const input = el.tagName === "INPUT" ? el : el.querySelector("input");
        if (input) {
          if (el._numberOnlyHandler) {
            input.removeEventListener("input", el._numberOnlyHandler);
          }
          if (el._compositionStartHandler) {
            input.removeEventListener(
              "compositionstart",
              el._compositionStartHandler
            );
          }
          if (el._compositionEndHandler) {
            input.removeEventListener(
              "compositionend",
              el._compositionEndHandler
            );
          }
          if (el._numberOnlyBlurHandler) {
            input.removeEventListener("blur", el._numberOnlyBlurHandler);
          }
        }

        // 清理保存的引用
        delete el._numberOnlyHandler;
        delete el._compositionStartHandler;
        delete el._compositionEndHandler;
        delete el._numberOnlyBlurHandler;
        delete el._maxDigits;
      },
    });
  },
};

export default numberLimit;
